import { sliderDotsAnimation } from '../utilities/slider-dots-animation'
import { elementsToMaxHeight } from '../utilities/elements-to-max-height'

let xs = 0
let sm = 600
let md = 800
let lg = 1200
let xl = 1400
let xxl = 2000
let modulesSlider = $('.js-extra-modules-slider')
let modulesSliderDots = $('.modules-mobile-dots')
let modulesCurrentSlide = $('.modules-current-slide')
let modulesCurrentDotsAnimation = $('.modules-dots-line-fill')

let contactForm = $('.contact-form')
contactForm.find('.form-tab-switch').addClass('active-form')
contactForm.find('.tab-link[data-tab="training"]').addClass('active')
contactForm.find('.forms form').hide()

$(window).on('popstate', function () {
  $.magnificPopup.close()
})

if (modulesSlider.length) {

  let modulesSliderSlick = modulesSlider.slick({
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: md,
        settings: {
          dots: true,
          slidesToShow: 2,
        }
      },
      {
        breakpoint: sm,
        settings: {
          dots: true,
          centerMode: true,
          centerPadding: '5vw',
          slidesToShow: 1,
        }
      },
    ]
  })

  modulesSliderSlick.on('beforeChange',
    function (event, slick, currentSlide, nextSlide) {
      updateDots(nextSlide + 1, slick.$slides.length)
    })

  /**
   * Set up popups for cloned content
   */
  modulesSliderSlick.on('afterChange', function(event, slick, currentSlide, nextSlide){
    $('.slick-cloned .mfp-popup-module-link').magnificPopup({
      closeBtnInside: true, type: 'inline', midClick: true,
      closeMarkup: '<div class="mfp-button-wrapper"><button title="%title%" type="button" class="mfp-close">&#215;</button></div>',
      callbacks: {
        open: function () {
          let module_content = this.content

          if (module_content.length) {
            history.pushState({}, null, '#' + module_content.attr('id'))
          }

        },
        close: function () {
          let homeUrl = $('body').data('home-url')
          history.pushState({}, null, '/' + homeUrl)
        }
      }
    })
  });

  /**
   * Slick carousel has fixed height with elementsToMaxHeight
   * when resizing, free that value
   */
  $(window).resize(function () {
    let slickElements = $('.module-card-outer-wrapper')
    slickElements.each(function () {
      slickElements.css('height', `auto`)
    })

    modulesSliderSlick.slick('setPosition')
  })

  $('body').on('click', '.modules-arrow', function (e) {
    if ($(this).hasClass('js-modules-prev')) {
      modulesSliderSlick.slick('prev')
    } else {
      modulesSliderSlick.slick('next')
    }
  })

  function updateDots (currentSlide, totalSlides) {
    let dotsPercent = (currentSlide / totalSlides) * 100
    modulesCurrentSlide.text(currentSlide)
    modulesCurrentDotsAnimation.width(`${dotsPercent}%`)
  }

  let slides = parseInt(modulesSlider.data('slides'))

  if (slides <= 3) {
    $('.extra-modules-slider-navigation').remove()
  }

  /**
   * Set up popups for normal content
   */
  $('.slick-slide .mfp-popup-module-link').magnificPopup({
    closeBtnInside: true, type: 'inline', midClick: true,
    closeMarkup: '<div class="mfp-button-wrapper"><button title="%title%" type="button" class="mfp-close">&#215;</button></div>',
    callbacks: {
      open: function () {
        let module_content = this.content

        if (module_content.length) {
          history.pushState({}, null, '#' + module_content.attr('id'))
        }

      },
      close: function () {
        let homeUrl = $('body').data('home-url')
        history.pushState({}, null, '/' + homeUrl)
      }
    }
  })

  $('.popup-learning-program .mfp-popup-contact-form-open').on('click', function () {
    $('.mfp-wrap').scrollTop(0)
  })


  $(window).on('load', function (e) {

    elementsToMaxHeight($('.module-card-outer-wrapper'))

    updateDots(1, slides)

    let moduleName = location.hash
    if (moduleName && moduleName.length > 1) {

      let moduleLink = $('.mfp-popup-module-link[href="' + moduleName + '"]')
      if (moduleLink.length) {

        $.magnificPopup.open({
          items: {
            src: moduleName
          },
          type: 'inline',
          callbacks: {
            close: function () {
              let homeUrl = $('body').data('home-url')
              history.pushState({}, null, '/' + homeUrl)
            }
          }

        })

        $('html, body').animate({
          scrollTop: $('#extra-modules').offset().top
        }, 10)

      }
    }

  })
}
